import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Nächte auf Google und Pinterest, um günstige Orte zu suchen.',
  good: 'Alle 20 Stationen sofort auf Ihrem Tablet — 2 Klicks.'
}, {
  bad: 'Stress an der Kasse: 103 CHF für eine Tageskarte.',
  good: 'Volle Sicherheit: Pässe ab 25 CHF.'
}, {
  bad: 'Teure SBB-Tickets weil man zu spät bucht.',
  good: '11 CHF Tickets mit unserem Sparkalender.'
}, {
  bad: '40 CHF für ein mittelmässiges Essen auf dem Berg.',
  good: 'Insider-Hütten mit echtem Alpkäse unter 20 CHF.'
}];
export function ComparisonTable() {
  return <section className="py-8 px-4" data-id="element-52">
      <div className="max-w-xl mx-auto" data-id="element-53">
        <div className="flex justify-between text-xs font-bold text-gray-400 mb-4 px-2 uppercase tracking-wider" data-id="element-54">
          <span data-id="element-55">Ohne Swiss Peak System</span>
          <span data-id="element-56">Mit Swiss Peak System</span>
        </div>
        <div className="space-y-3" data-id="element-57">
          {comparisons.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-card border border-white/10 rounded-2xl p-4 space-y-2.5" data-id="element-58">
              <div className="flex gap-3 items-start" data-id="element-59">
                <div className="mt-0.5 bg-red-500/15 p-1 rounded-full shrink-0" data-id="element-60">
                  <XIcon className="w-4 h-4 text-red-500" strokeWidth={3} data-id="element-61" />
                </div>
                <p className="text-gray-400 font-medium text-sm sm:text-base" data-id="element-62">
                  {item.bad}
                </p>
              </div>
              <div className="flex gap-3 items-start" data-id="element-63">
                <div className="mt-0.5 bg-green-500/15 p-1 rounded-full shrink-0" data-id="element-64">
                  <CheckIcon className="w-4 h-4 text-green-500" strokeWidth={3} data-id="element-65" />
                </div>
                <p className="text-brand-cream font-bold text-sm sm:text-base" data-id="element-66">
                  {item.good}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-lg font-bold text-brand-orange mt-8 mb-6" data-id="element-67">
          Fangen Sie an, den Montag morgen wieder zu lieben.
        </motion.p>
      </div>
    </section>;
}